// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import ArrowLeftSwitch from 'assets/icons/ArrowLeftSwitch.svg';
import ArrowRightSwitch from 'assets/icons/ArrowRightSwitch.svg';
import styles from './DateSwitcher.module.scss';

interface DateSwitcherProps {
  initialDate: Date;
  maxArrayPosition: number;
  onDateChange: (newDate: Date, fechaMesAñoArrayPosition: number) => void;
  fechaMesAñoArrayPositionDad: number;
}

const DateSwitcher = (props: DateSwitcherProps): JSX.Element => {
  const { initialDate, onDateChange, maxArrayPosition, fechaMesAñoArrayPositionDad } = props;

  const noHayNextFecha = fechaMesAñoArrayPositionDad >= maxArrayPosition;
  const noHayPreviousFecha = fechaMesAñoArrayPositionDad <= 0;

  const handlePrevious = () => {
    if (fechaMesAñoArrayPositionDad <= 0) return;
    const newDate = new Date(initialDate);
    if (newDate.getMonth() === 0) {
      newDate.setFullYear(newDate.getFullYear() - 1);
      newDate.setMonth(11);
    } else {
      newDate.setMonth(newDate.getMonth() - 1);
    }
    onDateChange(newDate, fechaMesAñoArrayPositionDad - 1);
  };

  const handleNext = () => {
    if (fechaMesAñoArrayPositionDad >= maxArrayPosition) return;
    const newDate = new Date(initialDate);
    if (newDate.getMonth() === 11) {
      newDate.setFullYear(newDate.getFullYear() + 1);
      newDate.setMonth(0);
    } else {
      newDate.setMonth(newDate.getMonth() + 1);
    }
    onDateChange(newDate, fechaMesAñoArrayPositionDad + 1);
  };

  return (
    <div className={styles.monthYearSwitcherContainer}>
      <button className={styles.switchButton} type="button" onClick={handlePrevious} disabled={noHayPreviousFecha}>
        <img src={ArrowLeftSwitch} alt="Arrow Left" />
      </button>
      <button className={styles.switchButton} type="button" onClick={handleNext} disabled={noHayNextFecha}>
        <img src={ArrowRightSwitch} alt="Arrow Right" />
      </button>
    </div>
  );
};

export default DateSwitcher;
